import { createAction, handleActions } from 'redux-actions';

const showProcurementItemModal = createAction("SCREENS/ORDER_VIEW/SHOW_PROCUREMENT_ITEM_MODAL");
const hideProcurementItemModal = createAction("SCREENS/ORDER_VIEW/HIDE_PROCUREMENT_ITEM_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [showProcurementItemModal]: () => true,
    [hideProcurementItemModal]: () => false,
    'RESET_ORDER_VIEW': () => defaultState,
  },
  defaultState
);

export { showProcurementItemModal, hideProcurementItemModal, reducer };
